module.exports = __webpack_public_path__ + "static/media/contentExample1.0d0f5f80.png";